import Cartesian from '@FreeRider/Utils/Cartesian';
import Vehicle from '@FreeRider/Player/Vehicles/BaseVehicle';
import Track from '@FreeRider/Track';
import Camera from '@FreeRider/Camera';
import Screen from '@FreeRider/Screen';

class Mass
{
    private parent: Vehicle;

    public position: Cartesian;
    public vel: Cartesian;
    public old: Cartesian;
    public radius: number;
    public collide: boolean;
    public contact: boolean;
    public angle: number;
    public friction: number;

    /**
     * Constructor
     * @param parent
     */
    constructor(parent: Vehicle)
    {
        this.parent = parent;
        this.radius = 10;

        this.position = { x: 0, y: 0 };
        this.vel = { x: 0, y: 0 };
        this.old = { x: 0, y: 0 };

        this.reset();
    }

    /**
     * Returns parent
     */
    public getParent(): Vehicle
    {
        return this.parent;
    }

    /**
     * Sets the position of the mass
     * @param position
     */
    public setPosition(position: Cartesian): void
    {
        this.position.x = position.x;
        this.position.y = position.y;
        this.old.x = position.x;
        this.old.y = position.y;
    }

    /**
     * Sets the velocity of the mass
     * @param velocity
     */
    public setVelocity(velocity: Cartesian): void
    {
        this.vel.x = velocity.x;
        this.vel.y = velocity.y;
    }

    /**
     * Reset
     */
    public reset()
    {
        this.position.x = 0;
        this.position.y = 0;
        this.vel.x = 0;
        this.vel.y = 0;
        this.old.x = 0;
        this.old.y = 0;
        this.collide = true;
        this.contact = false;
        this.angle = 0;
        this.friction = 0;
    }

    /**
     * Update
     */
    public update(track: Track)
    {
        const parent = this.parent;
        const velocity = this.vel;
        const position = this.position;
        const oldPosition = this.old;

        const gravity = parent.gravity;

        velocity.x += gravity.x;
        velocity.y += gravity.y;

        if (gravity.x !== 0 || gravity.y !== 0)
        {
            velocity.x = velocity.x * 0.99;
            velocity.y = velocity.y * 0.99;
        }

        position.x += velocity.x;
        position.y += velocity.y;

        this.contact = false;

        if (this.collide)
        {
            track.collide(this);
        }

        velocity.x = position.x - oldPosition.x;
        velocity.y = position.y - oldPosition.y;

        oldPosition.x = position.x;
        oldPosition.y = position.y;
    }

    /**
     * Dries the mass
     * @param x
     * @param y
     */
    public drive(x: number, y: number)
    {
        var friction = this.friction;

        var dot = -(x * this.vel.x + y * this.vel.y) * friction;

        x = x * dot;
        y = y * dot;

        this.position.x += x;
        this.position.y += y;

        this.contact = true;
    }

    /**
     * Draw Mass
     * Mainly used for debug purposes
     * @param canvasCtx
     * @param camera
     * @param screen
     */
    public draw(canvasCtx: CanvasRenderingContext2D, camera: Camera, screen: Screen)
    {
        const zoom = camera.zoom;
        const radius = this.radius;
        const position = this.position;

        var draw_x = (this.position.x - camera.x) * zoom + (screen.width / 2);
        var draw_y = (this.position.y - camera.y) * zoom + (screen.height / 2);

        canvasCtx.beginPath();
        canvasCtx.fillStyle = 'rgba(255,0,0,0.5)';
        canvasCtx.arc(draw_x, draw_y, radius * zoom, 0, 2 * Math.PI, false);
        canvasCtx.fill();
        canvasCtx.closePath();
    }
}

export default Mass;